import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginButtom: 16,
    minWidth: 128,
    width: "100%",
    backgroundColor: "white",
    borderRadius: 5,
    paddingLeft: 3,
  },
  selectText: {
    fontSize: 12,
  },
  select: {},
  filled: {},
  outlined: {},
  selectMenu: {},
  disabled: {},
  icon: {},
  iconOpen: {},
  iconFilled: {},
  iconOutlined: {},
  nativeInput: {},
  // div[class="^=MuiInput-underline"]:hover:not(div[class="^=MuiInput-disabled"]):not(div[class="^=MuiInput-focused"]):not(div[class="^=MuiInput-error"]):before
}));

const QuestionSelectBox = (props) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl}>
      <Select
        className={classes.selectText}
        value={props.value}
        required={props.required}
        onChange={(e) => props.select(e.target.value)}
      >
        {props.options.map((option) => {
          return (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default QuestionSelectBox;
